import { Loader } from "@googlemaps/js-api-loader"

export default class Maps {
    static init(apiKey) {
        return new Maps(apiKey);
    }

    constructor(apiKey) {
        const self = this;

        if (!window.CookieConsent) {
            console.error('Cookie Byte is not implemented or not initialized. Please initialize before initialization of Map Victoria');
            return;
        }

        if (window.CookieConsent.hasConsent('google-maps')) {
            self.loadMaps(apiKey);
        } else {
            window.CookieConsent.registerCallback('google-maps', function() {
                self.loadMaps(apiKey);
            }, this);
        }
    }

    async loadMaps(apiKey) {
        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.importLibrary("maps").then(() => {
            loader.importLibrary("marker").then(() => {
                let maps = document.querySelectorAll('.windwheel-map .map');
                maps.forEach((map) => {
                    this.setupMap(map);
                });
            });
        });
    }

    setupMap(mapElement) {
        if (!mapElement) return;

        let centerLat = Number(mapElement.getAttribute('data-center-lat'));
        let centerLng = Number(mapElement.getAttribute('data-center-lng'));
        let zoomLevel = Number(mapElement.getAttribute('data-zoom'));

        if (window.innerWidth < 500)
            zoomLevel -= 1;

        let mapOptions = {
            zoom: zoomLevel,
            center: new google.maps.LatLng(centerLat, centerLng),
            streetViewControl: false,
            overviewMapControl: false,
            mapTypeControl: false,
            fullscreenControl: true,
            mapId: 'DEMO_MAP_ID'
            /* styles: GoogleMapStyling */
        };

        let map = new google.maps.Map(mapElement, mapOptions);

        const markers = this.drawMarks(map, mapElement);

        map.addListener('zoom_changed', () => {
            if (map.getZoom() <= 10) {
                markers.forEach((marker) => {
                    marker.map = null;
                });
            }
            
            if (map.getZoom() > 10) {
                markers.forEach((marker) => {
                    marker.map = map;
                });
            }
        });
    }

    drawMarks(map, mapElement) {
        const wheelsJson = mapElement.getAttribute('wheels');
        const wheels = wheelsJson ? JSON.parse(wheelsJson) : [];
        const markers = [];

        Object.entries(wheels).forEach(function ([key, value]) {
            this.addFacility(map, value[0]);
            value.forEach((wheel, index) => {
                if (index != 0) {
                    const marker = this.addWheel(map, wheel);
                    if (marker)
                        markers.push(marker);
                }
            });
        }, this);

        return markers;
    }

    addFacility(map, pin) {
        if (!pin.x || typeof pin.x != 'number') 
            return;

        const iconElement = document.createElement('div');

        iconElement.innerHTML = `
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle id="Ellipse 18" cx="6" cy="6.23096" r="6" fill="${pin['color']['color']}"/>
            </svg>
        `;

        // draw facility

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: pin.y, lng: pin.x },
            map: map,
            content: iconElement
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `
            <div style="padding: 10px; max-width: 400px;" class="flex flex-col gap-2 font-normal">
                <h3>${pin.project}</h3>
                <p>${pin.facilityInfo}</p>
                <p>${pin.typeInfo}</p>
                <p>${pin.householdInfo}</p>
            </div>
            `,
        });
        
        google.maps.event.addListener(marker, 'click', () => {
            infoWindow.open({
                anchor: marker,
                map: map,
                shouldFocus: false, // Prevents focus from shifting to the popup
            });
        });

        return marker;
    }

    addWheel(map, pin) {
        if (!pin.x || typeof pin.x != 'number')
            return;

        const iconElement = document.createElement('div');
        iconElement.innerHTML = `
        <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
            <image href="/svg/ellipse.svg" width="10" height="10" />
        </svg>
        `;

        // draw facility

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: pin.y, lng: pin.x },
            map: null,
            content: iconElement
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `
            <div style="padding: 10px; max-width: 400px;" class="flex flex-col gap-2 font-normal">
                <h3>${pin.project}</h3>
                <p>${pin.facilityInfo}</p>
                <p>${pin.typeInfo}</p>
                <p>${pin.householdInfo}</p>
            </div>
            `,
        });
        
        google.maps.event.addListener(marker, 'click', () => {
            infoWindow.open({
            anchor: marker,
            map: map,
            shouldFocus: false, // Prevents focus from shifting to the popup
            });
        });

        return marker;
    }
}